module.exports = __webpack_public_path__ + "img/vizualPRiMedia.a8e655ba.png";